export default __webpack_public_path__ + "static/media/video.9eaacba5.mp4";